import * as yup from 'yup';
import { TResetPasswordFormValues } from './ResetPassword.types';
import type { TLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.types';

export const getResetPasswordSchema = (localize: TLocalize) =>
  yup
    .object<TResetPasswordFormValues>()
    .shape({
      password: yup
        .string()
        .required(localize('validation.auth.password.required') as string)
        .min(8, localize('validation.auth.password.min') as string)
        .test(
          'has-number',
          localize('validation.auth.password.number') as string,
          (value) => {
            return value ? /\d/.test(value) : false;
          }
        )
        .test(
          'has-capital',
          localize('validation.auth.password.capital') as string,
          (value) => {
            return value ? /[A-Z]/.test(value) : false;
          }
        )
        .test(
          'has-symbol',
          localize('validation.auth.password.symbol') as string,
          (value) => {
            return value
              ? /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value)
              : false;
          }
        ),
      confirmPassword: yup
        .string()
        .required(
          localize('validation.auth.password.confirm.required') as string
        )
        .oneOf(
          [yup.ref('password')],
          localize('validation.auth.password.confirm.match') as string
        ),
    });
